<div>
  <h6 class="nmbcol">  {{ 'Sellers.Products.BuyersInformation' | translate }} </h6>
  <form [formGroup]="stepForm" *ngIf="stepForm">
    <div class="row justify-content-center">
      <div class="col-lg-12 col-xl-12">
        <p style="margin-right: 30px;" class="d-flex mx-auto m-0 p-0">
          {{ 'Sellers.Products.EnterFields' | translate }}
        </p>
        <app-form-builder-fielditem (formBuilderSave)="addingFormBuilderStep($event)"></app-form-builder-fielditem>
      </div>
    </div>
  </form>
</div>
